import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { axiosGet, axiosPost } from "../../api/Axios";

export const getAllFormulasApi = createAsyncThunk(
  "/admin/formulas/getAllFormulas",
  async (
    {
      page,
      searchTerm,
      formulaStatus,
    }: { page: number; searchTerm?: string; formulaStatus?: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await axiosGet<IFormula[]>(
        `/admin/formulas/getAllFormulas?page=${page}&searchTerm=${searchTerm}&formulaStatus=${formulaStatus}`
      ); // Replace with your profile endpoint
      return response; // Return the user profile data
    } catch (error) {
      return rejectWithValue(error); // Return the error message
    }
  }
);

export const getMiniFormulasApi = createAsyncThunk(
  "/admin/formulas/getFormulasMini",
  async (filter: number = 1, { rejectWithValue }) => {
    try {
      const response = await axiosGet<IFormula[]>(
        `/admin/formulas/getFormulasMini`
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createNewFormulaApi = createAsyncThunk(
  "admin/formulas/createNewFormula",
  async (formulaData: ICreateNewFormulaApi, { rejectWithValue }) => {
    try {
      const response = await axiosPost<
        ICreateNewFormulaApi,
        CreateOrUpdateApisResponse
      >("/admin/formulas/createNewFormula", formulaData);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateFormulaStatusApi = createAsyncThunk(
  "admin/formulas/updateFormulaStatus",
  async (formulaData: IUpdateFormulaStatusApi, { rejectWithValue }) => {
    try {
      const response = await axiosPost<
        IUpdateFormulaStatusApi,
        CreateOrUpdateApisResponse
      >("/admin/formulas/updateFormulaStatus", formulaData);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const deleteFormulaApi = createAsyncThunk(
  "admin/formulas/deleteFormulaById",
  async (formulaData: IDeleteFormulaApi, { rejectWithValue }) => {
    try {
      const response = await axiosPost<
        IDeleteFormulaApi,
        CreateOrUpdateApisResponse
      >("/admin/formulas/deleteFormulaById", formulaData);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const updateFormulaDetailsApi = createAsyncThunk(
  "admin/formulas/updateFormulaDetails",
  async (formulaData: IUpdateFormulaDetailsApi, { rejectWithValue }) => {
    try {
      const response = await axiosPost<
        IUpdateFormulaDetailsApi,
        CreateOrUpdateApisResponse
      >("/admin/formulas/updateFormulaDetails", formulaData);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState: IFormulasSliceProp = {
  errors: [],
  isError: false,
  isFormulasApiLoading: true,
  formulasData: [],
  miniFormulas: [],
};

export const ordersSlice = createSlice({
  name: "formulas",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(getAllFormulasApi.pending, (state) => {
        state.isFormulasApiLoading = true;
        state.isError = false;
      })
      .addCase(getAllFormulasApi.fulfilled, (state, action) => {
        state.isFormulasApiLoading = false;
        state.formulasData = action.payload;
      })
      .addCase(getAllFormulasApi.rejected, (state, action) => {
        state.isFormulasApiLoading = false;
        state.isError = true;
        state.errors = [action.payload as string];
      })
      .addCase(getMiniFormulasApi.pending, (state) => {
        state.isFormulasApiLoading = true;
        state.isError = false;
      })
      .addCase(getMiniFormulasApi.fulfilled, (state, action) => {
        state.isFormulasApiLoading = false;
        state.miniFormulas = action.payload;
      })
      .addCase(getMiniFormulasApi.rejected, (state, action) => {
        state.isFormulasApiLoading = false;
        state.isError = true;
        state.errors = [action.payload as string];
      });
  },
});

export const {} = ordersSlice.actions;

export default ordersSlice.reducer;
